"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Portal = void 0;
const react_1 = require("react");
const react_dom_1 = __importDefault(require("react-dom"));
function Portal({ parent, children }) {
    const el = (0, react_1.useMemo)(() => document.createElement('div'), []);
    (0, react_1.useEffect)(() => {
        const target = (parent === null || parent === void 0 ? void 0 : parent.appendChild) ? parent : document.body;
        const classList = ['portal-container'];
        el.classList.add(...classList);
        target.appendChild(el);
        return () => {
            target.removeChild(el);
        };
    }, [el, parent]);
    return react_dom_1.default.createPortal(children, el);
}
exports.Portal = Portal;
//# sourceMappingURL=Portal.js.map